<template>
    <div class="flex items-center gap-2">
        <span class="flex-1">{{ label }}</span>
        <SelectDrawer :presets="options" :model-value="modelValue" @update:modelValue="updateValue">
            {{ modelValue ? options.find((o) => o.value === modelValue)?.label : $t('general.select') }}
        </SelectDrawer>
    </div>
</template>

<script>
import SelectDrawer from '../SelectDrawer.vue';

export default {
    name: 'CustomSelect',
    components: {
        SelectDrawer,
    },
    props: {
        modelValue: {
            default: '',
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        label: {
            type: String,
            default: '',
        },
    },
    computed: {
        columns() {
            return this.options.length
        },
    },
    methods: {
        updateValue(value) {
            this.$emit('update:modelValue', value)
        },
    },
}
</script>

<style scoped>

</style>
